

















































































import Vue, { PropType } from 'vue'
import UiAddButton from '../../UiAddButton'
import UiIcon from '../../UiIcon'
import UiImage from '../../UiImage'
import UiBuyButton from '../../UiBuyButton'
import { ProductContent, ProductImage } from '../UiSeriesList.types'

export default Vue.extend({
  name: 'UiSeriesItem',
  components: {
    UiAddButton,
    UiIcon,
    UiImage,
    UiBuyButton
  },
  props: {
    content: {
      type: Object as PropType<ProductContent>,
      required: true
    },
    image: {
      type: Object as PropType<ProductImage>,
      required: true
    },
    addText: {
      type: String,
      default: 'Add to comparison'
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    lockAdding: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggleProductHandler (): void {
      this.isSelected ? this.$emit('remove', this.content.buyButtonEan) : this.$emit('add', this.content.buyButtonEan)
    },
    handleLinkClick (): void {
      this.$gtm && this.$gtm.push({
        event: 'user action',
        gaEventCategory: 'productview',
        gaEventAction: 'detail', // VAR = overview / detail / zubehoer / ...
        gaEventLabel: this.content.header, // VAR = if overview = RT; RK; .. | if detail = RK1000 ...
        gaEventValue: '1' // Fest =  1
      })
    }
  }
})
